import { render, staticRenderFns } from "./NestRu.vue?vue&type=template&id=5baafabe&scoped=true&"
import script from "./NestRu.vue?vue&type=script&lang=js&"
export * from "./NestRu.vue?vue&type=script&lang=js&"
import style0 from "./NestRu.vue?vue&type=style&index=0&id=5baafabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baafabe",
  null
  
)

export default component.exports